import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { StepProgressGroup } from 'components/shared/StepProgressGroup/StepProgressGroup'
import { CategoryDetails } from './common/CategoryDetails/CategoryDetails'
import { CategoryEdit } from './common/CategoryEdit/CategoryEdit'

import {
  InterviewsCreatorHandlersContext,
  InterviewsCreatorStateContext,
} from 'components/modules/creators/TemplatesCreator/tabs/Interviews/context'
import { useContext } from 'hooks'

import styles from './Main.module.scss'

export const Main = () => {
  const state = useContext(InterviewsCreatorStateContext)
  const handlers = useContext(InterviewsCreatorHandlersContext)

  const {
    activeStep,
    steps,
    isEditMode,
    isIdleMode,
    isNextStepDisabled,
    isPreviousStepDisabled,
  } = state
  const {
    handleChangeNextStep,
    handleChangePreviousStep,
    handleChangeStep,
  } = handlers

  return (
    <Box
      align="center"
      className={styles.main}
      direction="column"
      tagName="main"
    >
      <StepProgressGroup
        className={cx(styles.steps, { [styles.edit]: isEditMode })}
        size="large"
        steps={steps}
        hasActions={!isEditMode}
        isNextDisabled={isEditMode || isNextStepDisabled}
        isPreviousDisabled={isEditMode || isPreviousStepDisabled}
        onNextStep={handleChangeNextStep}
        onPreviousStep={handleChangePreviousStep}
        onStep={handleChangeStep}
        {...{ activeStep }}
      />
      <Box align="center" className={styles.container}>
        {isIdleMode ? (
          <CategoryDetails key={activeStep} />
        ) : (
          <CategoryEdit key={activeStep} />
        )}
      </Box>
    </Box>
  )
}
